import { v4 as uuid } from 'uuid';
import { compact, map } from 'lodash';
import { toUUID } from '../../util/transform';
import { epoch, utc } from '../../util/datetime';
import { RiskInsuranceProductType } from './RiskInsuranceProduct.enum';
import { PaymentFrequency } from '../global/PaymentFrequency.enum';
import { YesNoOption } from '../global/YesNoOption.enum';
import type { IRiskInsuranceProduct } from './RiskInsuranceProduct.interface';

export default class RiskInsuranceProduct implements IRiskInsuranceProduct {
  id: string;
  productType: RiskInsuranceProductType;
  name: string;
  policyNumber: string;
  value: number;
  premium: number;
  premiumFrequency: PaymentFrequency;
  renewalDate: number;
  idContacts: Array<string>;
  areThereAnyPolicyExclusionsForThisClient: YesNoOption;
  howLongAreTheExclusions: string;
  listPolicyExclusions: string;
  isThePremiumWeighed: YesNoOption;
  howMuchIsItWeighed: string;
  howLongIsItWeighedFor: string;
  timeStamp: number;
  isActive: boolean;

  static build = (data: IRiskInsuranceProduct) => new RiskInsuranceProduct(data);
  static blank = (productType: RiskInsuranceProductType) =>
    new RiskInsuranceProduct({ id: uuid(), productType, isActive: true });

  /**
   * Constructor
   * @param {IRiskInsuranceProduct} data
   */
  constructor(data?: IRiskInsuranceProduct) {
    this.id = toUUID(data?.id) || uuid();
    this.productType = RiskInsuranceProductType.of(data?.productType?.name);
    this.name = data?.name || '';
    this.policyNumber = data?.policyNumber || '';
    this.value = parseFloat(data?.value || 0);
    this.premium = parseFloat(data?.premium || 0);
    this.premiumFrequency = PaymentFrequency.of(data?.premiumFrequency?.name);
    this.renewalDate = data?.renewalDate ? epoch(utc(data?.renewalDate)) : 0;
    this.idContacts = map(compact(data?.idContacts), (obj) => toUUID(obj));
    this.areThereAnyPolicyExclusionsForThisClient = YesNoOption.of(
      data?.areThereAnyPolicyExclusionsForThisClient?.name
    );
    this.howLongAreTheExclusions = data?.howLongAreTheExclusions || '';
    this.listPolicyExclusions = data?.listPolicyExclusions || '';
    this.isThePremiumWeighed = YesNoOption.of(data?.isThePremiumWeighed?.name);
    this.howMuchIsItWeighed = data?.howMuchIsItWeighed || '';
    this.howLongIsItWeighedFor = data?.howLongIsItWeighedFor || '';
    this.timeStamp = epoch(utc(data?.timeStamp));
    this.isActive = data?.isActive === true;
  }
}
